/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from 'rebass';

import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';
import Truncator from '../../../components/Truncator';

import { truncatorProps } from '../../constants';

import { formatSeasonRange } from '../../util';

export const columnSortModifiersFindProductCodes = {
  catalogId: null,
  catalogName: null,
  groupName: null,
  seasons: { disabled: true },
  owner: null
};

export const columnFilterModifiersFindProductCodes = {
  catalogId: { expression: 'Like' },
  groupName: { expression: 'Like' },
  catalogName: { expression: 'Like' },
  seasons: {
    expression: 'Includes',
    value: input => {
      // correct the input season format. For example from SP22 to SP2022
      if (/^[a-zA-Z]{2}\d{2}$/.test(input)) {
        const season = input.substr(0, 2);
        const year = input.substr(2);

        return `${season}20${year}`;
      }

      return input;
    }
  },
  owner: { expression: 'Like' }
};

export const getFindProductsColumns = () => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog ID' tableInstance={tableInstance} align='right' />,
      width: 130,
      accessor: 'catalogId',
      Cell: ({ value }) => (
        <Link to={`/catalogs/edit/${value}`} className='catalogs__link'>
          {value?.substr(0, 7)}
        </Link>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Catalog Name' tableInstance={tableInstance} />,
      width: 350,
      accessor: 'catalogName',
      Cell: ({ value }) =>
        value?.split?.(' ')?.length > 1 ? (
          value
        ) : (
          <Box>
            <Truncator value={value} {...truncatorProps} />
          </Box>
        )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Group Name' tableInstance={tableInstance} />,
      accessor: 'groupName',
      width: 350,
      Cell: ({ value }) =>
        value?.split?.(' ')?.length > 1 ? (
          value
        ) : (
          <Box>
            <Truncator value={value} {...truncatorProps} />
          </Box>
        )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Season' tableInstance={tableInstance} />,
      width: 120,
      accessor: 'seasons',
      Cell: ({ value }) => {
        return formatSeasonRange(value);
      }
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Owner' tableInstance={tableInstance} />,
      accessor: 'owner',
      Cell: ({ value }) => value?.split('@')[0]
    }
  ];
};
